(function () {
  'use strict';

  var gallery = document.getElementById('portrait-gallery');
  var moreBtn = document.getElementById('gallery-more');
  if (!gallery || !moreBtn) return;

  var items = gallery.querySelectorAll('.portrait__gallery-item');
  if (items.length === 0) return;

  // Read initial count from section settings (data attribute)
  var initialCount = parseInt(gallery.dataset.initial, 10) || 12;
  var shown = initialCount;

  // Hide items beyond initial count
  if (items.length > initialCount) {
    for (var i = initialCount; i < items.length; i++) {
      items[i].hidden = true;
    }
    moreBtn.style.display = '';
  }

  moreBtn.addEventListener('click', function () {
    var next = Math.min(shown + 12, items.length);
    for (var i = shown; i < next; i++) {
      items[i].hidden = false;
    }
    shown = next;
    if (shown >= items.length) {
      moreBtn.style.display = 'none';
    }
  });
})();
